import { Outlet, RouteObject } from 'react-router';
import Loader from 'router/Loader';
import { lazy } from 'react';

const DepartmentsPage = Loader(
  lazy(() => import('content/pages/Private/Departments')),
);

const DepartmentsRouter: RouteObject[] = [
  {
    path: 'departments',
    element: <Outlet />,
    children: [
      {
        path: '',
        element: <DepartmentsPage />,
      },
    ],
  },
];

export default DepartmentsRouter;
